export default "__VITE_ASSET__DGFGblLo__"